(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ps-deals-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-deals-timer')) {
    const LONDON = 'Europe/London';
    const partsAt = (ms) => {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: LONDON,
        hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).formatToParts(new Date(ms));
      const v = {};
      parts.forEach((p) => { v[p.type] = parseInt(p.value, 10); });
      return v;
    };

    // Offset (in minutes) of Europe/London from UTC at the given instant.
    const londonOffset = (ms) => {
      const v = partsAt(ms);
      const asUtc = Date.UTC(v.year, v.month - 1, v.day, v.hour, v.minute, v.second);
      return Math.round((asUtc - Math.floor(ms / 1000) * 1000) / 60000);
    };

    // UK wall-clock time -> epoch ms
    const londonToEpoch = (y, mo, d, h, mi, s) => {
      const guess = Date.UTC(y, mo - 1, d, h, mi, s);
      let ms = guess - londonOffset(guess) * 60000;
      ms = guess - londonOffset(ms) * 60000;
      return ms;
    };

    // "YYYY-MM-DD HH:MM" entered as UK local time -> epoch ms (null when invalid).
    const parseLondon = (text) => {
      const m = String(text || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return null;
      const ms = londonToEpoch(+m[1], +m[2], +m[3], +(m[4] || 0), +(m[5] || 0), 0);
      return Number.isNaN(ms) ? null : ms;
    };

    // Next Sunday 23:59:59 UK time (today, if it is Sunday and not over yet).
    const nextSunday = () => {
      const now = Date.now();
      const v = partsAt(now);
      const weekday = new Date(Date.UTC(v.year, v.month - 1, v.day)).getUTCDay(); // 0 = Sunday
      const ahead = (7 - weekday) % 7;
      let end = londonToEpoch(v.year, v.month, v.day + ahead, 23, 59, 59);
      if (end <= now) end = londonToEpoch(v.year, v.month, v.day + ahead + 7, 23, 59, 59);
      return end;
    };

    class PsDealsTimer extends HTMLElement {
      connectedCallback() {
        this.weekly = this.dataset.mode === 'weekly';
        this.endMs = this.weekly ? nextSunday() : parseLondon(this.dataset.end);
        this.refs = {
          d: this.querySelector('[data-days]'),
          h: this.querySelector('[data-hours]'),
          m: this.querySelector('[data-mins]'),
          s: this.querySelector('[data-secs]'),
        };
        if (this.endMs === null || this.endMs <= Date.now()) {
          this.hidden = true;
          return;
        }
        this.tick();
        this.hidden = false;
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        let left = this.endMs - Date.now();
        if (left <= 0) {
          if (this.weekly) {
            this.endMs = nextSunday();
            left = this.endMs - Date.now();
          } else {
            clearInterval(this.timer);
            this.hidden = true;
            return;
          }
        }
        const total = Math.floor(left / 1000);
        const pad = (n) => String(n).padStart(2, '0');
        this.refs.d.textContent = pad(Math.floor(total / 86400));
        this.refs.h.textContent = pad(Math.floor((total % 86400) / 3600));
        this.refs.m.textContent = pad(Math.floor((total % 3600) / 60));
        this.refs.s.textContent = pad(total % 60);
      }
    }
    customElements.define('ps-deals-timer', PsDealsTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-hero-slider')) {
    class PsHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.toggleBtn = this.querySelector('[data-toggle]');
        this.index = 0;
        this.userPaused = false;
        this.hovering = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.delay = parseInt(this.dataset.delay, 10) || 6000;
        this.wantsAutoplay =
          this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduceMotion &&
          !(window.Shopify && window.Shopify.designMode);

        if (!this.track || this.slides.length < 1) return;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            const w = this.track.clientWidth || 1;
            this.setActive(Math.round(this.track.scrollLeft / w));
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1, true));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1, true));
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.dot, 10), true))
        );
        if (this.toggleBtn) {
          this.toggleBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.toggleBtn.setAttribute('aria-pressed', String(this.userPaused));
            this.toggleBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
            this.userPaused ? this.stop() : this.start();
          });
        }
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1, true); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1, true); }
        });
        this.addEventListener('mouseenter', () => { this.hovering = true; this.stop(); });
        this.addEventListener('mouseleave', () => { this.hovering = false; this.start(); });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('touchstart', () => this.stop(), { passive: true });
        this.addEventListener('touchend', () => this.start(), { passive: true });
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.visible = entries[0].isIntersecting;
            this.visible ? this.start() : this.stop();
          });
          this.io.observe(this);
        } else {
          this.visible = true;
        }

        this.onBlockSelect = (e) => {
          const slide = e.target.closest('[data-slide]');
          if (slide && this.contains(slide)) this.goTo(this.slides.indexOf(slide), true);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.setActive(0);
        this.start();

        // Slides off screen start lazy; once the page has loaded fetch them all so no tile is blank when it slides in.
        const loadAll = () => this.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
        if (document.readyState === 'complete') setTimeout(loadAll, 200);
        else window.addEventListener('load', () => setTimeout(loadAll, 200), { once: true });
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.io) this.io.disconnect();
      }

      setActive(i) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        const changed = i !== this.index;
        this.index = i;
        this.slides.forEach((slide, n) => {
          const active = n === i;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('inert');
            slide.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
          } else {
            slide.setAttribute('inert', '');
          }
        });
        this.dots.forEach((dot, n) => {
          const active = n === i;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        // Lets assets/ps-motion.js replay the slide's entrance animation (nothing listens when motion is off)
        if (changed) {
          this.dispatchEvent(new CustomEvent('ps-hero:change', { bubbles: true, detail: { index: i, slide: this.slides[i] } }));
        }
      }

      goTo(i, user) {
        const n = this.slides.length;
        const target = ((i % n) + n) % n;
        const wrapped = Math.abs(target - this.index) > 1 && n > 2;
        this.track.scrollTo({
          left: target * this.track.clientWidth,
          behavior: this.reduceMotion || wrapped ? 'auto' : 'smooth',
        });
        if (user) this.restart();
      }

      step(dir, user) {
        this.goTo(this.index + dir, user);
      }

      start() {
        if (!this.wantsAutoplay || this.userPaused || this.hovering || document.hidden || this.visible === false) return;
        if (this.timer) return;
        this.timer = setInterval(() => this.step(1, false), this.delay);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('ps-hero-slider', PsHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
